import {
    SET_NEW_FEATURE,
    REMOVE_FEATURE,
    GET_FEATURES,
    EDIT_FEATURE,
    UPLOAD_FILE
} from "./types";

import firebase from "firebase/app";
import moment from "moment"

export const getFeatures = () => {
    return dispatch => {
        dispatch({ type: GET_FEATURES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_FEATURES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/features")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_FEATURES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_FEATURES.FAIL });
        }
    };
};
export const setNewFeature = (feature) => {
    return dispatch => {
        dispatch({ type: SET_NEW_FEATURE.REQUEST });
        let count_id;
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) dispatch({ type: SET_NEW_FEATURE.FAIL });
                firebase
                    .database()
                    .ref(`/subjects/features`)
                    .once("value")
                    .then(async function(snapshot) {
                        count_id = snapshot.val(); // "last"
                        if (
                            typeof count_id !== "undefined" &&
                            count_id !== null
                        )
                        feature["feature_id"] = (
                                "000000" +
                                (parseInt(
                                    Object.keys(count_id)[
                                        Object.keys(count_id).length - 1
                                    ]
                                ) +
                                    1)
                            ).slice(-6);
                        else feature["feature_id"] = "000001";
                        feature["feature_image"]=await uploadMessageImages(feature["feature_image"],feature["feature_id"])
                        firebase
                            .database()
                            .ref("/subjects/features")
                            .child(feature.feature_id)
                            .update(feature);
                        dispatch({ type: SET_NEW_FEATURE.SUCCESS });
                    });
            });
        } catch (e) {
            dispatch({ type: SET_NEW_FEATURE.FAIL });
        }
    };
};

export const uploadMessageImages = async (
    imgBlob = false,
    featureID = false
) => {
    if (imgBlob && featureID) {
        let imgUploadURL = firebase
            .storage()
            .ref(`/featureImages/${featureID}/featureImg`)
            .put(imgBlob)
            .then(async snapshot => {
                try {
                    const url = await snapshot.ref.getDownloadURL();
                    return url;
                } catch (e) {
                    return false;
                }
            })
            .catch(() => {
                return false;
            });
        return imgUploadURL;
    } else {
        return false;
    }
};

export const editFeature = (feature) => {
    return dispatch => {
        dispatch({ type: EDIT_FEATURE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged( async user => {
                if (user === null) {
                    dispatch({ type: EDIT_FEATURE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/subjects/features/${feature.feature_id}`)
                        .update(feature);
                    
                    dispatch({ type: EDIT_FEATURE.SUCCESS });
                    
                }
            });
        } catch (e) {
            dispatch({ type: EDIT_FEATURE.FAIL });
        }
    };
};



export const removeFeature = uid => {
    return dispatch => {
        dispatch({ type: REMOVE_FEATURE.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_FEATURE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/features")
                        .child(uid)
                        .update({feature_deleted:true})
                        // .remove();
                    dispatch({ type: REMOVE_FEATURE.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: REMOVE_FEATURE.FAIL });
        }
    };
};

export const emailFeature = (feature, callback ) => {
    return dispatch => {
        let cloudFunction = firebase.functions().httpsCallable("featureRequest");
        try {
            cloudFunction(feature).then(e => {
                callback(true);
            });
        } catch (e) {
            callback(false);
        }
    };
};
/* Upload Multiple Images */
export const uploadFile = (featureName, file, callback) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
 
        let upload = firebase
            .storage()
            .ref(`support/${featureName}`)
            .child(file.name)
            .put(file);
 
        upload.on(
            "state_changed",
            snapshot => {
                let progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
 
                callback({
                    fileExists: false,
                    inProgress: true,
                    finished: false,
                    error: false,
                    progress: progress,
                    msg: "Upload is " + progress + "% done"
                });
            },
            () => {
                // Handle unsuccessful uploads
                callback({
                    fileExists: false,
                    inProgress: false,
                    finished: false,
                    error: true,
                    msg: "Something went wrong with this upload!"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            },
            () => {
                //success
                upload.snapshot.ref.getDownloadURL().then(url => {
                    callback({
                        fileExists: false,
                        inProgress: false,
                        finished: true,
                        error: false,
                        msg: "Success",
                        url
                    });
                });
            }
        );
    };
};
export const uploadFileManager = (
    file = false,
    file_type = "help_documents",
    successCallback,
    newAttachedFile
) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });
        let newFileID = await getNewFileID();
        let fileExists = await doesFileExist(file.name, file_type);

        try {
            if (!fileExists) {
                let upload = firebase
                    .storage()
                    .ref(`file_manager/help_documents`)
                    .child(file.name)
                    .put(file);

                upload.on(
                    "state_changed",
                    snapshot => {
                        let progress =
                            (snapshot.bytesTransferred / snapshot.totalBytes) *
                            100;

                        successCallback({
                            fileExists: false,
                            inProgress: true,
                            finished: false,
                            error: false,
                            progress: progress,
                            msg: "Upload is " + progress + "% done"
                        });
                    },
                    () => {
                        successCallback({
                            fileExists: false,
                            inProgress: false,
                            finished: false,
                            error: true,
                            msg: "Something went wrong with this upload!"
                        });
                        dispatch({ type: UPLOAD_FILE.FAIL });
                    },
                    () => {
                        upload.snapshot.ref.getDownloadURL().then(url => {
                            let newFile = {
                                file_id: newFileID,
                                file_name: file.name,
                                file_size: file.size,
                                file_url: url,
                                file_directory: file_type,
                                date_added: new moment().format(
                                    "DD-MM-YYYY hh:mm:ss"
                                ),
                                file_folder: file_type,
                                file_type: file.type
                            };
                            newAttachedFile({
                                file: file.name,
                                fileURL: url,
                                file_type,
                                file_id: newFileID
                            });
                            firebase
                                .database()
                                .ref(`/subjects/file_manager/help_documents/${newFileID}/`)
                                .set(newFile)
                                .then(() => {
                                    dispatch({
                                        type: UPLOAD_FILE.SUCCESS
                                    });
                                    successCallback({
                                        fileExists: false,
                                        inProgress: false,
                                        finished: true,
                                        error: false,
                                        msg: "Success"
                                    });
                                });
                        });
                    }
                );
            } else {
                newAttachedFile(fileExists);
                successCallback({
                    fileExists: true,
                    inProgress: false,
                    finished: false,
                    error: false,
                    msg: "Success"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            }
        } catch {
            dispatch({ type: UPLOAD_FILE.FAIL });
        }
    };
};
export const getNewFileID = async () => {
    let files = await getFiles();

    let newFileID;
    if (files) {
        let IDs = Object.keys(files).map(e => {
            return  Object.values(files[e]).map(f => {
                 return f.file_id
             })
         })
         let fileIDs =  Math.max(...[].concat(...IDs));
        newFileID = (Number(fileIDs) + 1).toString().padStart(6, "0");
        return newFileID;
    } else if (files == null) {
        newFileID = "000001";
        return newFileID;
    }
};
export const doesFileExist = async (name, directory) => {
    let files = await getFiles();

    let flag = false;
    if (files) {
        Object.keys(files).map(index => {
            if (
                files[index].file_name === name &&
                files[index].file_directory === directory
            )
                flag = {
                    file: files[index].file_name,
                    fileURL: files[index].file_url,
                    file_type: files[index].file_type,
                    file_id: files[index].file_id
                };
            return null;
        });
        return flag;
    } else if (files == null) {
        return false;
    }
};
export const getFiles = async () => {
    let files = await firebase
        .database()
        .ref(`subjects/file_manager`)
        .once("value");
    return files.val();
};